<script lang="ts">
	import { createSelect, melt } from '@melt-ui/svelte';
	import IconChevronDown from '~icons/mdi/chevron-down';
	import IconCheck from '~icons/mdi/check-box-outline';
	import IconCheckboxEmpty from '~icons/mdi/square-outline';
	import { inputClasses } from '$lib/InputText.svelte';

	type Props = {
		options: string[];
		placeholder?: string;
		value: string;
		required?: boolean;
		class?: string;
	};
	let {
		options,
		placeholder = 'Bitte auswählen',
		value = $bindable(''),
		required = false,
		class: className,
	}: Props = $props();

	const {
		elements: { trigger, menu, option },
		states: { selectedLabel, open, selected },
		helpers: { isSelected },
	} = createSelect({
		forceVisible: true,
		required,
		positioning: {
			placement: 'bottom',
			fitViewport: true,
			sameWidth: true,
		},
		multiple: true,
	});

	$effect(() => {
		if (value?.trim().length > 0) {
			$selected = value.split(',').map((x) => ({ label: x.trim(), value: x.trim(), disabled: false }));
		}
	});

	$effect(() => {
		value = $selectedLabel;
	});
</script>

<div class="">
	<button
		class="{inputClasses} flex min-w-32 items-center justify-between {className}"
		use:melt={$trigger}
		aria-label="Food"
		type="button"
	>
		{#if $selectedLabel}
			{$selectedLabel}
		{:else}
			<span class="text-violet-300">{placeholder}</span>
		{/if}
		<IconChevronDown class="ml-4 inline-block size-6 translate-x-2 text-neutral-500" />
	</button>

	<!-- for form validation messages -->
	<input
		class="opacity-1 -z-20 float-left m-0 max-h-0 max-w-0 translate-x-24 p-0 opacity-0"
		bind:value={$selectedLabel}
		{required}
	/>

	{#if $open}
		<div
			class=" z-10 flex max-h-[300px] flex-col overflow-y-auto rounded-md border border-violet-500 bg-violet-50 p-1 shadow-md focus:!ring-0"
			use:melt={$menu}
		>
			{#each options as item}
				<div
					class="relative cursor-pointer rounded-md p-2 text-neutral-800 focus:z-10 focus:text-violet-700 data-[highlighted]:bg-violet-100 data-[selected]:font-semibold data-[highlighted]:text-violet-900 data-[selected]:text-violet-900"
					use:melt={$option({ value: item, label: item })}
				>
					<IconCheck class="inline-block size-5 text-violet-800 {$isSelected(item) ? 'block' : 'hidden'}" />
					<IconCheckboxEmpty class="inline-block size-5 text-violet-800 {!$isSelected(item) ? 'block' : 'hidden'}" />

					<span class="ml-1">
						{item}
					</span>
				</div>
			{/each}
		</div>
	{/if}
</div>
